import StatusBadge from '@components/StatusBadge'
import { breakpoints } from '@constants'
import { paths } from 'mmfintech-backend-api'
import type { CounterpartyResponse } from 'mmfintech-backend-api/types'
import { isValidArray, tr, useMatchMedia } from 'mmfintech-commons'
import { DataTable } from 'mmfintech-portal-commons'
import { useHistory } from 'react-router-dom'

import './counterpartyTable.scss'

const { Table, Row, HeadCell, Head, Body, Cell } = DataTable

type CounterpartyTableProps = {
  data: CounterpartyResponse[]
}

const CounterpartyTable = ({ data }: CounterpartyTableProps) => {
  const history = useHistory()
  const isMobile = useMatchMedia({ breakpoint: breakpoints.md, prefix: 'max' })

  const handleCounterpartyRowClick = (counterparty: CounterpartyResponse) => {
    history.push(paths.expenseManagement.counterpartyDetails(counterparty.id))
  }

  return (
    <div className='counterparty-table-wrapper table-container'>
      <Table>
        <Head>
          <Row className='headRow'>
            <HeadCell colSpan={2}>{tr('FRONTEND.COUNTERPARTY.COLUMN_NAME', 'Name')}</HeadCell>
            <HeadCell>{tr('FRONTEND.COUNTERPARTY.COLUMN_TOTAL_EXPENSES', 'Total')}</HeadCell>
            <HeadCell className={isMobile ? 'text-right' : ''}>
              {tr('FRONTEND.COUNTERPARTY.COLUMN_AWAITING_PAYMENT', 'Awaiting Payment')}
            </HeadCell>
            {!isMobile && (
              <>
                <HeadCell>{tr('FRONTEND.COUNTERPARTY.COLUMN_PAID', 'Paid')}</HeadCell>
                <HeadCell className='text-right'>{tr('FRONTEND.COUNTERPARTY.COLUMN_STATUS', 'Status')}</HeadCell>
              </>
            )}
          </Row>
        </Head>

        <Body>
          {isValidArray(data)
            ? data.map((counterparty: CounterpartyResponse) => {
                const { expenseMetrics } = counterparty
                return (
                  <Row
                    className='table-row'
                    key={counterparty.id}
                    onClick={() => handleCounterpartyRowClick(counterparty)}
                  >
                    <Cell colSpan={2}>
                      <div>{counterparty.name}</div>
                      {isMobile && <StatusBadge status={counterparty.state} />}
                    </Cell>
                    <Cell>{expenseMetrics?.totalExpensesCount}</Cell>
                    <Cell className={isMobile ? 'text-right' : ''}>{expenseMetrics?.outstandingExpensesCount}</Cell>
                    {!isMobile && (
                      <>
                        <Cell>{expenseMetrics?.paidExpensesCount}</Cell>
                        <Cell className='text-right'>
                          <StatusBadge status={counterparty.state} />
                        </Cell>
                      </>
                    )}
                  </Row>
                )
              })
            : null}
        </Body>
      </Table>
    </div>
  )
}

export default CounterpartyTable
